export const filtering = (bool)=>{
    return bool ? {
        type:"SHOW_FILTER",
        data:bool
    }: {
        type: "HIDE_FILTER",
        data: bool
    }
}